module.exports = {"620523100":"大像山镇","620523101":"磐安镇","620523102":"新兴镇","620523103":"安远镇","620523104":"六峰镇","620523105":"金山镇","620523106":"大庄镇","620523108":"大石镇","620523109":"礼辛镇","620523113":"武家河镇","620523204":"八里湾乡","620523205":"西坪乡","620523211":"谢家湾乡","620523214":"古坡乡","620523215":"白家湾乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620523.json
// module id = 2699
// module chunks = 0